import { Dispatch, SetStateAction } from 'react';

import { Dayjs } from 'dayjs';

import CustomDateRangePicker from './CustomDateRangePicker';

interface NPIDateRangePickerProps {
    defaults: {
        from: Dayjs;
        to: Dayjs;
    };
    setDate: Dispatch<
        SetStateAction<{
            from: Dayjs;
            to: Dayjs;
        }>
    >;
}

/**
 * NPI's controlled custom date range picker component with set default values that also holds the state of the dates
 * @example
 * const [reportDate, setReportDate] = useState<{
      from: Dayjs | null
      to: Dayjs | null
    }>({
      from: dayjs('2024-06-01'),
      to: dayjs(),
    })

 * ...

 *  <NPIDateRangePicker
      defaults={reportDate}
      setDate={(d) => setReportDate(d)}
    />
 * @returns A custom date range picker component with two date pickers for "From" and "To" dates.
 */

const NPIDateRangePicker = ({ defaults, setDate }: NPIDateRangePickerProps) => {
    return (
        <CustomDateRangePicker
            value={[defaults.from, defaults.to]}
            onChange={(newValue) => {
                setDate({ from: newValue[0], to: newValue[1] });
            }}
        />
    );
};

export default NPIDateRangePicker;
